import { useQuery } from 'react-query';

import { getQuestionGroups } from 'App/services/AMSService';

function useFetchAssessmentQuestionGroups() {
    return useQuery(['questionGroups'], getQuestionGroups, {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchAssessmentQuestionGroups;
